<template>
    <div class="wrapper">
        <Tabs :cryptoCurrency="cryptoCurrency"
              :fiatCurrency="fiatCurrency"
              :chartType="chartType"
              :defaultTabIndex="defaultTabIndex"
              :defaultRangeIndex="defaultRangeIndex"
              :defaultTabTitle="Object.keys(chartTypeTitles[0])[0]"
              :tabTitles="chartTypeTitles"
              @toggleFs="toggleFs($event)"
              @setLogarithmicAxis="setLogarithmicAxis($event)"
              @loadChart="activateChart($event)"
              @timeframeChange="timeframeKey = $event">
            <Tab v-if="chartType.includes('price') && activeView === 'price'"
                 :title="getTrans('cryptocurrencies.price')">
                <PriceChart ref="priceChart"
                            :key="timeframeKey"
                            :dataRange="range"
                            :chartTimeframeKey="timeframeKey" />
            </Tab>
            <Tab v-if="chartType.includes('market-cap') && activeView === 'market-cap'"
                 :title="getTrans('cryptocurrencies.marketCap')">
                <MarketCapChart ref="marketCap"
                                :key="timeframeKey"
                                :dataRange="range" />
            </Tab>
            <Tab v-if="chartType.includes('candlestick') && activeView === 'candlestick'"
                 :title="getTrans('cryptocurrencies.candlestick')">
                <CandlestickChart ref="candlestick"
                                  :key="timeframeKey"
                                  :dataRange="range" />
            </Tab>
            <Tab v-if="cryptoCurrency.trading_view_pair && chartType.includes('trading-view') && activeView === 'trading-view'"
                 title="TradingView">
                <TradingViewChart :tradingViewPair="cryptoCurrency.trading_view_pair" />
            </Tab>
        </Tabs>
    </div>
</template>

<script>
    import PriceChart from './PriceChart.vue';
    import MarketCapChart from './MarketCapChart.vue';
    import TradingViewChart from './TradingViewChart.vue';
    import CandlestickChart from './CandlestickChart.vue';
    import Tab from './Tab.vue';
    import Tabs from './Tabs.vue';
    import { getTrans } from '../helpers/getTrans';

    export default {
        name: 'ChartWrapper',
        components: {
            CandlestickChart,
            TradingViewChart,
            MarketCapChart,
            PriceChart,
            Tab,
            Tabs,
        },
        props: {
            cryptoCurrency: {
                type: Object,
                required: true,
                default: () => ({}),
            },
            fiatCurrency: {
                type: String,
                required: true,
            },
            chartType: {
                type: Array,
                default: () => ['price', 'market-cap', 'candlestick', 'trading-view'],
                required: false,
            },
            defaultTabIndex: {
                type: Number,
                default: 0,
                required: false,
            },
            defaultRangeIndex: {
                type: Number,
                default: 0,
                required: false,
            },
        },
        data() {
            return {
                activeView: '',
                range: {},
                timeframeKey: '',
            };
        },
        computed: {
            chartTypeTitles() {
                return this.chartType.map((type) => {
                    if (type === 'trading-view') {
                        return { [type]: 'TradingView' };
                    }
                    const formattedTitle = type.split('-').map((word, index) => {
                        if (index === 0) {
                            return word;
                        }

                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join('');

                    return { [type]: formattedTitle };
                });
            },
        },
        methods: {
            getTrans,
            toggleFs(ref) {
                const refMap = {
                    price: 'priceChart',
                    'market-cap': 'marketCap',
                    candlestick: 'candlestick',
                };
                const propName = refMap[ref];
                if (propName) {
                    this.$refs[propName].toggleFs();
                }
            },
            setLogarithmicAxis(ref) {
                const refMap = {
                    price: 'priceChart',
                    'market-cap': 'marketCap',
                    candlestick: 'candlestick',
                };
                const { title, isLogarithmic } = ref;
                const propName = refMap[title];
                if (propName) {
                    this.$refs[propName]?.toggleLogAxes(isLogarithmic);
                }
            },
            activateChart(payload) {
                if (payload.range && payload.slug) {
                    this.range = payload;
                }
                if (payload.title) {
                    this.activeView = payload.title;
                }
            },
        },
    };
</script>
